import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/* Lightweight CSS device frames so real screenshots read as "product". */

export function BrowserFrame({
  children,
  url,
  className,
}: {
  children: ReactNode
  url?: string
  className?: string
}) {
  return (
    <div
      dir="ltr"
      className={cn(
        'overflow-hidden rounded-xl border bg-card shadow-lift ring-1 ring-black/5 dark:ring-white/5',
        className
      )}
    >
      <div className="flex items-center gap-2 border-b bg-muted/60 px-3 py-2">
        <span className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-red-400/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-amber-400/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-emerald-400/80" />
        </span>
        {url && (
          <span className="mx-auto truncate rounded-md bg-background/80 px-3 py-0.5 text-[11px] text-muted-foreground">
            {url}
          </span>
        )}
      </div>
      <div className="relative">{children}</div>
    </div>
  )
}

export function PhoneFrame({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      dir="ltr"
      className={cn(
        'relative rounded-[1.35rem] border-4 border-slate-900 bg-slate-900 shadow-lift sm:rounded-[2rem] sm:border-[6px] dark:border-slate-700 dark:bg-slate-700',
        className
      )}
    >
      <span className="absolute start-1/2 top-1 z-10 h-1 w-8 -translate-x-1/2 rounded-full bg-slate-700 sm:top-1.5 sm:h-1.5 sm:w-14 dark:bg-slate-500" />
      <div className="overflow-hidden rounded-[1.05rem] bg-white sm:rounded-[1.55rem]">{children}</div>
    </div>
  )
}
